import Vue from 'vue'
import { Button, Card, Input, Loading, Progress, Tag } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

locale.use(lang)

Vue.use(Button)
Vue.use(Loading)
Vue.use(Card)
Vue.use(Progress)
Vue.use(Tag)
Vue.use(Input)
